import PropTypes from 'prop-types'
import React from 'react'

const LogoOutline24 = ({
   className,
   color,
   height,
   strokeWidth,
   width
}) => (
   <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24">
      <g
         className={className}
         strokeLinecap="square"
         strokeLinejoin="miter"
         strokeWidth={strokeWidth}
         fill={color}
         stroke={color}>
         <circle cx="18.5" cy="8.5" fill="none" r="4.5" />
         <rect height="7" width="7" fill="none" x="6" y="15" />
         <polygon fill="none" points="2 10 6 3 10 10 2 10" />
      </g>
   </svg>
)

LogoOutline24.propTypes = {
   className: PropTypes.string,
   color: PropTypes.string,
   height: PropTypes.string,
   strokeWidth: PropTypes.string,
   width: PropTypes.string
}

LogoOutline24.defaultProps = {
   className: undefined,
   color: '#444',
   height: '24px',
   strokeWidth: '1',
   width: '24px'
}

export default React.memo(LogoOutline24)
